import React from "react";
import Select from "react-select";

const SelectComponent = (props)=>{
    return (
        <div >
            <label className="block font-medium ">{props.label}</label>
            <Select options={props.options??[]} {...props} isClearable={true} isDisabled={props.isDisabled??false}/>
        </div>
    )
}

export default SelectComponent;